module.exports = __webpack_public_path__ + "static/media/titre_sauces.ae6ac14d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/titre_sauces.png
// module id = 278
// module chunks = 0